import 'jquery-validation/dist/jquery.validate';

const moduleName = 'form',
	selector = {
		base: `.js-${moduleName}`,
		select: `select`
	},
	classNames = {
		loading: '.is-loading'
	};

export default class Form {

    constructor(baseElement) {

        if (baseElement === null) {
            return false;
        }

		this.form = baseElement;
		this.$form = $(this.form);

        this.init();
	}

	setValidators() {
		const methods = $.validator.methods;
		if (typeof methods.customEmail === 'undefined') {
			$.validator.addMethod('customEmail', function (value, element) {
				// allow any non-whitespace characters as the host part
				var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return this.optional(element) || pattern.test(value);
			}, 'Please enter a valid email address.');
        }

		if (typeof methods.pattern === 'undefined') {
			$.validator.addMethod("pattern", function (value, element, param) {
				if (this.optional(element)) {
					return true;
				}
				if (typeof param === "string") {
					param = new RegExp("^(?:" + param + ")$");
				}
				return param.test(value);
			}, "Invalid format.");
		}
    }

	// validate element
	validateElement(element) {
		$(element).valid();
    }

	validateForm() {
		this.$form.validate({
			focusInvalid: true,
			errorPlacement: function (error, element) {
				$(element).closest('form').find('button[type="submit"]').removeClass('is-loading');
				const $select2 = $(element).siblings('.select2');
				const $error = error.addClass('c-form__input__msg c-form__input__msg--error');

				if ($select2.length) {
					$error.insertAfter($select2);
				} else {
					$error.insertAfter(element);
				}
			},
			highlight: function (element) {
				$(element).closest('.js-input').addClass('-error');
				$(element).closest('form').find('.js-form-feedback').hide();
			},
			unhighlight: function (element) {
				$(element).closest('.js-input').removeClass('-error');
			},
			ignore: ':hidden'
		});
	}

	onChangeHandler(element) {
		this.validateElement(element);
    }

	onSubmitHandler(ev) {
		if (this.$form.valid()) {
			this.form.querySelector('button[type="submit"]').classList.add(classNames.loading);
		} else {
			dataLayer.push({
				'event': 'scorecard_create_error',
				'eventCategory': 'scoreCard',
				'eventAction': 'create',
				'eventLabel': 'complete',
				'error_type': 'form_validation'
			});
        }
    }

	bindEvents() {
		this.form.removeEventListener('submit', (ev) => this.onSubmitHandler(ev));
		this.form.addEventListener('submit', (ev) => this.onSubmitHandler(ev));

		// Validate dropdowns on change
		this.form.querySelectorAll(selector.select).forEach((element) => {
			element.addEventListener('change', () => this.onChangeHandler(element));
		});
    }


    /**
     * 
     **/
	init() {
		this.setValidators();
		this.validateForm();
		this.bindEvents();
    }
}